exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loader[data-v-2ceebd6a]{width:20px;height:20px;margin:auto}\n", ""]);
